// extracted by mini-css-extract-plugin
export var actionIcon = "SquareCard-module--actionIcon--fc1d2";
export var body = "SquareCard-module--body--b6930";
export var cdsAssistiveText = "SquareCard-module--cds--assistive-text--62f32";
export var cdsHideFeedback = "SquareCard-module--cds--hide-feedback--93089";
export var cdsShowFeedback = "SquareCard-module--cds--show-feedback--35bed";
export var cdsSkeleton = "SquareCard-module--cds--skeleton--d192f";
export var cdsVisuallyHidden = "SquareCard-module--cds--visually-hidden--49344";
export var darkMode = "SquareCard-module--darkMode--60624";
export var disabled = "SquareCard-module--disabled--f1ff4";
export var helperIcon = "SquareCard-module--helperIcon--c46db";
export var helperText = "SquareCard-module--helperText--8287c";
export var squareCard = "SquareCard-module--squareCard--45b8f";
export var title = "SquareCard-module--title--17f95";
export var titleSmall = "SquareCard-module--titleSmall--4423c";